package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

/** Un compte masqué par l'appelant (#515, ADR 0029), ligne de « Comptes masqués ». */
@Serializable
data class BlockedUserDto(
    val userId: Long,
    val username: String,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val blockedAt: Instant,
)

/** Réponse de `GET /api/v1/me/blocks`, le plus récent d'abord. */
@Serializable
data class BlockedUsersResponse(
    val users: List<BlockedUserDto>,
)

/** Corps de `POST /api/v1/users/{id}/report`. [details] facultatif, borné par `UserReportLimits`. */
@Serializable
data class CreateUserReportRequest(
    val kind: String,
    val details: String? = null,
)

/** Corps de `POST /api/v1/harvests/{id}/reports`. Seul `INAPPROPRIATE_CONTENT` est admis. */
@Serializable
data class CreateHarvestReportRequest(
    val kind: String,
)
